import React from 'react';
import './styles.scss';

const CrosshairPoint = () => <div className="CrosshairPoint"></div>;

export default CrosshairPoint;
